import { Component, inject } from "@angular/core";
import { MessagesModule } from "primeng/messages";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { MergeProcessingService } from "../services/merge-processing.service";

@Component({
    selector: "merge-patients-processing",
    standalone: true,
    imports: [CommonModule, MessagesModule, ButtonModule],
    templateUrl: "./merge-patients-processing.component.html"
})
export class MergePatientsProcessingComponent {
    protected readonly processingService = inject(MergeProcessingService);
}
